import React from 'react';
import styles from './styles.module.css';

type Props = {
  className?: string;
  margin?: string;
};

export default function DividerHorizontal({ className = '', margin = '0 8px' }: Props) {
  return <div className={`${styles.divider} ${className}`} style={{ margin: `${margin}` }} />;
}
